import { context } from '@wikia/ad-engine';

export function getSeedtagContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {
				adhesion_limited: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.adhesion_limited ?? [
						[300, 50],
						[320, 50],
					],
					adUnitId: '33057481',
					publisherId: '3246-3878-01',
					placement: 'inScreen',
				},
			}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[320, 50],
						[320, 100],
					],
					publisherId: '7908-0833-01',
					adUnitId: '29832715',
					placement: 'inScreen',
				},
			};

	return {
		enabled: false,
		slots: {
			mobile_top_leaderboard: {
				sizes: context.get('experiments.oversizedAds')?.mobile?.mobile_top_leaderboard ?? [
					[320, 50],
					[320, 100],
				],
				publisherId: '7908-0833-01',
				adUnitId: '29832764',
				placement: 'inBanner',
			},
			mobile_prefooter: {
				sizes: [[300, 250]],
				publisherId: '7908-0833-01',
				adUnitId: '29832758',
				placement: 'inBanner',
			},
			...(context.get('seedtag.floorAdhesion') ? floorAdhesionConfigs : {}),
			featured: {
				sizes: [[0, 0]],
				publisherId: '7908-0833-01',
				adUnitId: '29832808',
				placement: 'inStream',
			},
		},
	};
}
